/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  TestContract,
  TestContractInterface,
} from "../../../contracts/test/TestContract";

const _abi = [
  {
    inputs: [],
    name: "AnError",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [],
    name: "DoEvenLess",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "DoNothing",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "Dynamic",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes4[]",
        name: "",
        type: "bytes4[]",
      },
    ],
    name: "Dynamic32",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes2[]",
        name: "",
        type: "bytes2[]",
      },
    ],
    name: "DynamicDynamic32",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "EmitTheSender",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "FnWithSingleParam",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "FnWithThreeParams",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "FnWithTwoMixedParams",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "FnWithTwoParams",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "Receive",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ReceiveEthAndDoNothing",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ReceiveFallback",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "test",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "test2",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "test3",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "test4",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "test5",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "string",
        name: "test6",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "test7",
        type: "string",
      },
    ],
    name: "TestDynamic",
    type: "event",
  },
  {
    inputs: [],
    name: "aStorageNumber",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "doEvenLess",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "doNothing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "first",
        type: "bytes",
      },
    ],
    name: "dynamic",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4[]",
        name: "first",
        type: "bytes4[]",
      },
    ],
    name: "dynamic32",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "first",
        type: "string",
      },
      {
        internalType: "bytes2[]",
        name: "second",
        type: "bytes2[]",
      },
    ],
    name: "dynamicDynamic32",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "dynamicString",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emitTheSender",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "maybe",
        type: "bool",
      },
    ],
    name: "fnThatMaybeReverts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "fnThatReverts",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "p",
        type: "uint256",
      },
    ],
    name: "fnWithSingleParam",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "c",
        type: "uint256",
      },
    ],
    name: "fnWithThreeParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "a",
        type: "bool",
      },
      {
        internalType: "string",
        name: "s",
        type: "string",
      },
    ],
    name: "fnWithTwoMixedParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
    ],
    name: "fnWithTwoParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "oneParamAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "b",
            type: "bytes",
          },
        ],
        internalType: "struct TestContract.DynamicTuple[]",
        name: "",
        type: "tuple[]",
      },
    ],
    name: "oneParamArrayOfDynamicTuple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    name: "oneParamArrayOfStatic",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "b",
            type: "bool",
          },
        ],
        internalType: "struct TestContract.StaticTuple[]",
        name: "",
        type: "tuple[]",
      },
    ],
    name: "oneParamArrayOfStaticTuple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "oneParamBytes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes1",
        name: "",
        type: "bytes1",
      },
    ],
    name: "oneParamBytesSmall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "oneParamBytesWord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "a",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "b",
                type: "bytes",
              },
            ],
            internalType: "struct TestContract.DynamicTuple",
            name: "b",
            type: "tuple",
          },
        ],
        internalType: "struct TestContract.DynamicNestedTuple",
        name: "",
        type: "tuple",
      },
    ],
    name: "oneParamDynamicNestedTuple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "b",
            type: "bytes",
          },
        ],
        internalType: "struct TestContract.DynamicTuple",
        name: "",
        type: "tuple",
      },
    ],
    name: "oneParamDynamicTuple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int8",
        name: "",
        type: "int8",
      },
    ],
    name: "oneParamIntSmall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    name: "oneParamIntWord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "oneParamStatic",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "a",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "b",
                type: "bool",
              },
            ],
            internalType: "struct TestContract.StaticTuple",
            name: "b",
            type: "tuple",
          },
        ],
        internalType: "struct TestContract.StaticNestedTuple",
        name: "",
        type: "tuple",
      },
    ],
    name: "oneParamStaticNestedTuple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "b",
            type: "bool",
          },
        ],
        internalType: "struct TestContract.StaticTuple",
        name: "",
        type: "tuple",
      },
    ],
    name: "oneParamStaticTuple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "oneParamString",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    name: "oneParamUintSmall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "oneParamUintWord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "receiveEthAndDoNothing",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "value",
        type: "uint16",
      },
    ],
    name: "setAStorageNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "revert_",
        type: "bool",
      },
    ],
    name: "spendAndMaybeRevert",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "test",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "test2",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "test3",
        type: "string",
      },
      {
        internalType: "bool",
        name: "test4",
        type: "bool",
      },
      {
        internalType: "uint8",
        name: "test5",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "test6",
        type: "string",
      },
      {
        internalType: "string",
        name: "test7",
        type: "string",
      },
    ],
    name: "testDynamic",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
    ],
    name: "twoParamsStatic",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "b",
            type: "bool",
          },
        ],
        internalType: "struct TestContract.StaticTuple",
        name: "",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "twoParamsStaticTupleStatic",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type TestContractConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestContractConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestContract__factory extends ContractFactory {
  constructor(...args: TestContractConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      TestContract & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): TestContract__factory {
    return super.connect(runner) as TestContract__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestContractInterface {
    return new Interface(_abi) as TestContractInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): TestContract {
    return new Contract(address, _abi, runner) as unknown as TestContract;
  }
}
